import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import BroadCastSection from "./broadCastSection";
import CreateBroadCast from "./createBroadCast/main";
import BroadCastDetail from "./broadcastDetail/main";
import * as DataAction from "../../../store/actions/data/DataAction";
import db from "../../../db/index.json";
import { useDispatch } from "react-redux";
// onClick={onBack}

const BroadCast = ({ onBack, onBackHome }) => {
  const { broadcasts } = db;
  const [showTable, setShowTable] = useState("table");
  const [detail, setDetails] = useState(null);
  const dispatch = useDispatch();
  const toggleDetail = (data) => {
    setDetails(data);
    setShowTable("detail"); // State toggle karein
  };

  const toggleCreate = () => {
    dispatch(DataAction.ChangeBroadcastCurrentStep(1));
    setShowTable("create"); // State toggle karein
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };
  const [search, setSearch] = useState("");

  return (
    <div>
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div className="h-screen">
                <div className="h-[10vh] pr-2">
                  <SearchBar
                    value={search}
                    onSearchChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    title={broadcasts.title}
                    desc={broadcasts.subTitle}
                  />
                </div>
                <div className="h-[90vh]">
                  <BroadCastSection
                    search={search}
                    onViewDetails={(data) => {
                      toggleDetail(data);
                    }}
                    onViewCreate={toggleCreate}
                  />
                </div>
              </div>
            );
          case "detail":
            return <BroadCastDetail detail={detail} onBack={toggleTable} />;
          case "create":
            return <CreateBroadCast onBackHome={onBackHome} />;
          default:
            break;
        }
      })()}
    </div>
  );
};

export default BroadCast;
